module.exports = __webpack_public_path__ + "static/media/bank.2e2e7c8c.svg";